import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludeFilter'
})
export class ExcludeFilterPipe implements PipeTransform {

  transform(value: any[] , filter?: any): any {
    if (!value || !filter) {
      return value;
  }
  return value.filter(item => item.name !== filter);
  }

}
